export const fieldsToCopyFromParentColumn = [
  'colId',
  'headerName',
  'headerClass',
  'companyCode',
  'countryTaxType',
  'isIncludedInTotalColumn',
] as const;
